import React, {useState, useEffect} from 'react'
import { Link } from 'react-router-dom'
import InputIcon from '../../../components/Form/InputIcon'
import Select from '../../../components/Form/Select'
import FindTalentCard from '../../components/Cards/FindTalentCard'
import back11 from '../../assets/images/juan-ramos-EWN0rrwbBIQ-unsplash2.jpg'
import filter from "../../assets/searchIcon/filter.svg"
// import TrainerCard from '../../components/Cards/TrainerCard'
import TrainerCard1 from '../../components/Cards/TrainerCard1'
import { useDispatch, useSelector } from 'react-redux'
import { fetchCandidates, setFilters  } from '../../../redux/CandidateSlice'
import ButtonBlack from '../../../components/Buttons/ButtonBlack'
import location from "../../assets/searchIcon/location.svg"
import RowPagination from "../../components/Pagination"

const FindTalent2 = () => {
    const dispatch = useDispatch();
    const { candidates, loading } = useSelector((state) => state.candidate);
    const [listStyle, setListStyle] = useState('md:grid-cols-1');
    const {user} = useSelector(store=>store.user);
    const [filters, setFilters] = useState({
      keyword: '',
      location: '',
      page: 1,
      limit: 10
    });
    // Déclenche la récupération des candidats avec les filtres actuels
    // useEffect(() => {
    //   dispatch(fetchCandidates(filters))
    // }, [filters, dispatch])

    useEffect(() => {
      dispatch(fetchCandidates(filters))
    }, [dispatch, filters.page])
  
    const handleFilterChange = (e) => {
      const { name, value, type, checked } = e.target
      if (type === 'checkbox') {
        setFilters({ [name]: checked ? value : '' })
      } else {
        setFilters({ ...filters, [name]: value })
      
      }
    };

    const handlePageChange = (newPage) => {
      setFilters((prev) => ({
        ...prev,
        page: newPage+1,
      }));
    };

    return (
        <div className=''>
          <div className="bg-purple-300 h-56 w-full p-responsive py-8 object-cover bg-cover bg-top " style={{ backgroundImage: `url(${back11})`}}>
            <div className="flex justify-between mb-10">
            <h5 className='font-semibold text-lg'>Candidat</h5>
            <li className="flex gap-x-2 text-sm items-center">
              <ul className="text-gray-600"> <Link to="/home">Accueil</Link>  / </ul>
              <ul className="font-medium">Candidat</ul>
            </li>
            </div>

            <div className="bg-white rounded-lg shadow h-auto p-2">
          <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-2">
            <div className=" col-span-3 w-full grid grid-cols-2">
            <InputIcon
              name="keyword"
              placeholder="Mot clé ..."
              noBorder={true}
              value={filters.keyword}
              onChange={handleFilterChange}
            />
            <InputIcon
              className="hidden xl:block"
              name="location"
              placeholder="Localisation"
              value={filters.location}
              icon={location}
              noBorder={true}
              onChange={handleFilterChange}
            />
            </div>
            <div className="flex items-center gap-x-2 gap-y-2">
              {/* <button 
                // onClick={() => setshowModal(true)} 
                className=" h-full w-[58px] justify-center flex items-center border border-[#E8E8E8] bg-[#FBFBFB] rounded-md flex gap-2 items-center">
                <img src={filter} alt="" />
              </button> */}
              <button onClick={()=>{
                 
                dispatch(fetchCandidates({   
                  location: filters.location,
                  keyword: filters.keyword,
                  page: 1,
                  limit: 10,
                }))
                }} className="p-4 py-3 bg-black rounded-md text-white font-medium w-full">
                Rechercher
              </button>
            </div>
          </div>
        </div>

          </div>
      {/* customise list display */}
      <div className="bg-white px-6 lg:px-20 xl:px-40 h-16 shadow-sm -6 py-3">
        <div className="flex justify-between items-center">
          <div className="flex gap-2 items-center"> 
          <span className="text-lg font-semibold"> {candidates?.total} Résultats </span>
          </div>

          <div className="flex gap-2 items-center"> 
          <span>Par page </span>
          <Select name="limit" className="w-40" options={["10", "15","30"]} mb='0' onChange={(e)=>setFilters({...filters, limit: e.target.value})}/> 
          
          {/* <LayoutSwitcher setListStyle={setListStyle} listStyle={listStyle} /> */}
          </div>
          
         
        </div>
      </div>

          <div className="flex-1 p-responsive bg-primary-beige py-6">
            <div className="flex gap-x-6">
              <div className="flex-1 ">
                <div className={'grid grid-cols-1  gap-6 '+listStyle}>
                  {candidates?.data?.map((item)=>{
                      return( 
                          listStyle === "md:grid-cols-1" ? 
                          <FindTalentCard key={item.id} item={item} user={user} />
                          :
                          <TrainerCard1 item={item}/>
                      )
                  })}
                </div>
              </div>


</div>
<RowPagination
    currentPage={filters?.page || 1}
    setCurrentPage={handlePageChange}
    totalPages={candidates?.last_page }
    />
          </div>
        </div>
      )
}

export default FindTalent2